import React from 'react';
import { Flex, GoodsCardSkeletonList, List } from '@banhala/ui-kit';
import { useAtomicProxyComponent } from './queries/useAtomicProxyComponent';
import { useLikeMap } from '../../../../hooks';
import { createAtomicComponent } from '../../utils/createAtomicComponent';

const ProxyContent: React.FC<{
  body: {
    item: {
      url: string;
    };
  };
}> = props => {
  const { data: proxyComponent } = useAtomicProxyComponent(props.body.item.url);
  const { likeMap, setLikeMap } = useLikeMap();
  return (
    <List
      data={proxyComponent?.components ?? []}
      keyExtractor={(component, index) =>
        `${props.body.item.url}-${component.componentId}-${index}`
      }
      renderItem={({ item, index }) =>
        createAtomicComponent({ component: item, index, likeMap, setLikeMap })
      }
    />
  );
};

export const Proxy: React.FC<{
  body: {
    item: {
      url: string;
    };
  };
}> = props => {
  return (
    <React.Suspense
      fallback={
        <Flex>
          <Flex.Row
            padding={{ horizontal: 16, vertical: 16 }}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Flex
              backgroundColor={'bg_tertiary'}
              width={98}
              height={24}
              borderRadius={4}
            ></Flex>
            <Flex
              backgroundColor={'bg_tertiary'}
              width={64}
              height={18}
              borderRadius={4}
            ></Flex>
          </Flex.Row>
          <Flex height={260}>
            <GoodsCardSkeletonList
              count={4}
              numColumns={3}
              bottomContentHeight={0}
            />
          </Flex>
        </Flex>
      }
    >
      <ProxyContent {...props} />
    </React.Suspense>
  );
};
